import React from "react";
import {Box, Card, CardContent, Grid, Typography} from "@mui/material";
import type {DashboardCard} from "../DashboardCardConfigs.tsx";
import {DashboardCardComponent} from "./DashboardCardComponent.tsx";

type Props = {
    icon: React.ReactNode
    title: React.ReactNode
    cards: DashboardCard[]
}
export const DashboardSection: React.FC<Props> = ({icon, title, cards}) => {
    const N = cards.length;
    const minSize = N <= 3 ? 4 : 3;
    return <Card variant="elevation" elevation={0} className="dashboard-section">
        <CardContent>
            <Box className="dashboard-section-header" display="flex" alignItems="center">
                {icon}
                <Typography component="h2" variant="h2">{title}</Typography>
            </Box>
            <Grid container spacing={3} className="dashboard-section-row" justifyContent="start">
                {cards.map(card =>
                    <DashboardCardComponent key={card} card={card} minSize={minSize}/>
                )}
            </Grid>
        </CardContent>
    </Card>
}
